import { createSlice } from '@reduxjs/toolkit'

export const pairsSlice = createSlice({
  name: 'pairs',
  initialState: {
    name: '',
    target: '',
    place: '',
  },
  reducers: {
    setName: (state, action) => {
      const value = action.payload;
      const formattedValue = value.charAt(0).toUpperCase() + value.slice(1);
      state.name = formattedValue.trim()
    },
    setTarget: (state, action) => {
      state.target = action.payload
    },
    setPlace: (state, action) => {
      state.place = action.payload
    },
  },
});

export const { setName, setTarget, setPlace } = pairsSlice.actions;

export const selectName = (state) => state.pairs.name;
export const selectTarget = (state) => state.pairs.target;
export const selectPlace = (state) => state.pairs.place;

export default pairsSlice.reducer
